// src/pages/services.jsx
import React from "react";
import "../Css/Servicepage.css";


import patient from "../assets/service-1.jpg";
import baby from "../assets/service-2.jpg";
import maid from "../assets/service-3.jpg";
import cook from "../assets/service-4.jpg";
import driver from "../assets/service-5.jpg";
import housemaid from "../assets/service-6.jpg";
import japamaid from "../assets/service-7.jpg";


const Servicepage = () => {
  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="about-hero">
        <div className="about-overlay">
          <div className="about-hero-content">
            <h1>Services</h1>
            <p>
              <span><a href="/">Home</a></span> /{" "}
              <span className="active">Services</span>
            </p>
          </div>
        </div>
      </section>

      {/* ================= SERVICES SECTION ================= */}
      <section className="services">
        {/* TOP TEXT */}
        <div className="services-top">
          <p>
           Tanya Maid Service is a leading provider of Trusted Maid in Mumbai. We specialize in offering reliable, skilled, and professional domestic help to households across the city. Our mission is to make your home life easier by providing maids who are experienced, responsible, and capable of managing all household chores efficiently. Whether you need assistance with cleaning, cooking, laundry, childcare, or elderly care, Tanya Maid Service is here to meet your needs.
          </p>

          <p>
            As a reputed agency, we also provide Affordable Maid in Mumbai without compromising on quality. Our focus is on delivering value and reliability, ensuring that every client receives professional support for their home. Our maids are background-verified, trained, and committed to maintaining the highest standards of service.
          </p>
        </div>

        {/* CARDS */}
        <div className="services-grid">
          {/* CARD */}
          <div className="service-card">
            <img src={patient} alt="Patient Care" />
            <div className="service-content">
              <h3>Patient Care</h3>
              <p>
                Tanya Maid Service provides compassionate and reliable patient care, ensuring comfort, safety, and support for your loved ones at home.
              </p>
              <a href="/services/patient-care" className="read-btn">
                READ MORE
              </a>
            </div>
          </div>

          {/* CARD */}
          <div className="service-card">
            <img src={baby} alt="Baby Care" />
            <div className="service-content">
              <h3>Baby Care</h3>
              <p>
                Tanya Maid Service provides dedicated and caring baby care maids, ensuring your child’s safety, comfort, and overall well being at home.
              </p>
              <a href="/services/baby-care" className="read-btn">
                READ MORE
              </a>
            </div>
          </div>

          {/* CARD */}
          <div className="service-card">
            <img src={maid} alt="House Maid" />
            <div className="service-content">
              <h3>House Maid</h3>
              <p>
                Tanya Maid Service provides reliable and professional house maids to keep your home organized, clean, and well managed.
              </p>
              <a href="/services/house-maid" className="read-btn">
                READ MORE
              </a>
            </div>
          </div>

          <div className="service-card">
            <img src={cook} alt="House Maid" />
            <div className="service-content">
              <h3>Cooking Maid Service</h3>
              <p>
                Tanya Maid Service offers skilled cooking maids who prepare healthy, hygienic, and delicious meals for your family with care and reliability.
              </p>
              <a href="/services/cooking" className="read-btn">
                READ MORE
              </a>
            </div>
          </div>

          <div className="service-card">
            <img src={driver} alt="House Maid" />
            <div className="service-content">
              <h3>Driver Services</h3>
              <p>
                Tanya Maid Service provides professional and trustworthy drivers to ensure safe, punctual, and comfortable travel for your family.
              </p>
              <a href="/services/driver" className="read-btn">
                READ MORE
              </a>
            </div>
          </div>
          
          <div className="service-card">
            <img src={housemaid} alt="House Maid" />
            <div className="service-content">
              <h3>Home Cleaning</h3>
              <p>
                Tanya Maid Service offers reliable home cleaning maids to keep your home spotless, organized, and comfortable every day.
              </p>
              <a href="/services/home-cleaning" className="read-btn">
                READ MORE
              </a>
            </div>
          </div>

          <div className="service-card">
            <img src={japamaid} alt="House Maid" />
            <div className="service-content">
              <h3>Japa Maid Services</h3>
              <p>
                Tanya Maid Service provides caring and experienced Japa maids to support new mothers and newborns with comfort, safety, and expert care at home.
              </p>
              <a href="/services/japa-maid" className="read-btn">
                READ MORE
              </a>
            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default Servicepage;
